export default __webpack_public_path__ + "static/media/icao_standard.06fa1375.png";